import { collection, doc, getDocs, writeBatch } from 'firebase/firestore';

const MAX_BATCH_OPS = 450; // stay below 500 writes per batch

export async function syncMemberCalendarToFamily(db, userId, familyId) {
  if (!db || !userId || !familyId) return;

  const snap = await getDocs(collection(db, `privateUsers/${userId}/calendar`));
  if (snap.empty) return;

  const docs = snap.docs;
  for (let i = 0; i < docs.length; i += MAX_BATCH_OPS) {
    const batch = writeBatch(db);
    const slice = docs.slice(i, i + MAX_BATCH_OPS);
    slice.forEach((d) => {
      const target = doc(db, `families/${familyId}/calendar/${d.id}`);
      batch.set(target, d.data(), { merge: true });
    });
    await batch.commit();
  }
}
